import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import {
  Checkbox,
  ExpandableContent
} from 'ui-shared-components';
import { formatPrice } from '@white-label-helper/helper-payment';
import IconTick from '@white-label-icon/icon-tick';
import IconButton from '@white-label-icon/icon-button';
import IconLink from '@white-label-icon/icon-link';

interface AddOn {
  name: string;
  price: number;
  selected: boolean;
}

interface Policy {
  document: string;
  coverage: string[];
  addOns: AddOn[];
}


interface AddOnWithExpanded extends AddOn {
  expanded: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'travel-insurance-policy',
  props: {
    policy: null
  },
  emits: ['addOnSelect'],
  setup(__props: any, { emit }) {

const props = __props as { policy: Policy };

const isOpen = ref(true);




const addOns = ref<AddOnWithExpanded[]>(props.policy.addOns.map(addOn => ({ ...addOn, expanded: false })));

function handleAddOnSelect(addOn: AddOnWithExpanded) {
  if (addOn) {
    addOn.selected = !addOn.selected;
  }
  emit('addOnSelect', addOns.value);
}

return { __sfc: true,isOpen, props, emit, addOns, handleAddOnSelect, Checkbox, ExpandableContent, formatPrice, IconTick, IconButton, IconLink }
}

})